import { atom, getDefaultStore } from 'jotai';

// Buffered signal for the invite-gated login flow: raised when an auth
// succeeds but the backend reports the user uninvited (invitedBy null in
// the auth response), consumed by the UI layer that owns the waitlist /
// invalid-invite modals. address is the authenticated wallet address, or
// null when the account carries none (email-only accounts) — informational,
// consumers only enrich analytics with it. ssoUsername names the rejected
// account: the issuer keeps that account's session alive, so retries
// silently resume it — consumers show which account was rejected and offer
// the switch-account escape. The atom lives in jotai's default store —
// every importer in the JS realm shares it, and non-React emitters write
// through getDefaultStore(). Emits may fire during app boot, before the
// consuming surface mounts — the atom buffers the payload until then.
//
// Exactly-once delivery is the CONSUMER'S job: it must clear the atom (set
// null) when it consumes the payload, or a remount re-fires the modal. A
// second emit before consumption overwrites the first (newest wins). Emits
// spread into a fresh object so a repeat emit of the SAME payload still
// re-notifies subscribers.
export const inviteRequiredAtom = atom<{
  address: string | null;
  ssoUsername?: string;
} | null>(null);

export function emitInviteRequired(payload: {
  address: string | null;
  ssoUsername?: string;
}): void {
  getDefaultStore().set(inviteRequiredAtom, { ...payload });
}
